export enum TableBodyColumn {
  CHECKBOX = 'checkbox',
  ACTIONS = 'actions'
}
